import React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";

const CustomReactTable = ({ columns, data }) => {
  // Ensure columns have a Header and accessor field
  const formattedColumns = columns.map((col) => ({
    Header: col.header, // ReactTable v6 expects 'Header' instead of 'header'
    accessor: col.accessorKey, // ReactTable v6 expects 'accessor' instead of 'accessorKey'
    Cell: col.cell, // Custom cell rendering if provided
    width: col.size || undefined, // Optional column width
  }));

  return (
    <ReactTable
      data={data}
      columns={formattedColumns}
      filterable={true}
      defaultPageSize={data.length}
      showPagination={false}
      className="-striped -highlight"
    />
  );
};

export default CustomReactTable;
